export default {
    namespaced: true,
    state: {
        lists: [],
        list: {}
    },
    getters: {
        lists(state) {
            return state.lists
        },
        list(state) {
            return state.list
        },
        productListsForCheck: state => productLists => {
            return state.lists.map(list => {
                const newList = { ...list }
                let isChecked = false

                productLists.map(productList => {
                    if (list.ListID === productList.ListID) {
                        isChecked = true
                    }
                })

                newList.checked = isChecked
                return newList
            })
        }
    },
    actions: {
        getLists({ commit }) {
            this.$axios
                .get('/retailer/lists')
                .then(({ data }) => {
                    commit('SET_LISTS', data)
                })
                .catch(e => console.log(e.response.data))
        },
        getListItem({ commit }, listID) {
            this.$axios
                .get(`/retailer/lists/${listID}`)
                .then(({ data }) => {
                    commit('SET_LIST', data)
                })
                .catch(e => console.log(e.response.data))
        },
        removeItem({ dispatch }, { listID, itemID }) {
            this.$axios
                .delete(`/retailer/items/${itemID}/list/${listID}`)
                .then(({ data }) => {
                    dispatch(
                        'retailerProducts/getProducts',
                        { lists: [listID] },
                        { root: true }
                    )
                    return data
                })
                .catch(e => console.log(e.response.data))
        },
        removeList(context, listID) {
            return this.$axios
                .delete(`/retailer/lists/${listID}`)
                .then(({ data }) => {
                    return data
                })
                .catch(e => console.log(e.response.data))
        },
        createList(context, listName) {
            return this.$axios
                .post(`/retailer/lists`, { ListName: listName })
                .then(({ data }) => {
                    return data
                })
                .catch(e => console.log(e.response.data))
        }
    },
    mutations: {
        SET_LISTS(state, lists) {
            state.lists = lists
        },
        SET_LIST(state, list) {
            state.list = list
        }
    }
}
